import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useMasterAuth } from '../context/MasterAuthContext';

export function RotaProtegidaMaster({ children }: { children: ReactNode }) {
  const { master, carregando } = useMasterAuth();

  if (carregando) {
    return null;
  }

  if (!master) {
    return <Navigate to="/master/login" replace />;
  }

  return <>{children}</>;
}
